import React, { useMemo } from "react";
import { Col, Row } from "reactstrap";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { Stack } from "@mui/material";
import { get } from "lodash";

import { getOptionLabel } from "common/enums";

const ViewUtilityConsumerMeterField = ({
  item: { heading, label, key, enumName, unit, isRequired },
  meterData = {},
  t,
}) => {
  const fieldValue = useMemo(() => get(meterData, key, ""), [meterData]);

  return heading ? (
    <Col xs={12} className="fs-4 fw-semibold mb-3 border-bottom mt-1">
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <div>{t(heading)}</div>
      </Stack>
    </Col>
  ) : (
    <Col md={6} className="mb-1 ">
      <Row>
        <Col md={7}>{t(label)}:</Col>
        <Col md={5} className="fw-semibold">
          {fieldValue ? (
            <span>
              {enumName ? getOptionLabel(enumName, fieldValue) : fieldValue}{" "}
              {unit ?? ""}
            </span>
          ) : isRequired ? (
            "-"
          ) : (
            "N/A"
          )}
        </Col>
      </Row>
    </Col>
  );
};

ViewUtilityConsumerMeterField.propTypes = {
  item: PropTypes.object,
  meterData: PropTypes.object,
  t: PropTypes.func,
};

export default withTranslation()(ViewUtilityConsumerMeterField);
